import apiClient from "@/libs/axios";
// import store from "@/state/store";
// import router from "@/router";

export const state = {
    data: [],
    details: null,
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setData: (state, data) => {
        state.data = data.result.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    setDetails: (state, data) => {
        state.details = data.result;
    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, is_active: data.is_active} : item)
    },

    deleteItem: (state, id) => {
        let data = state.data;
        state.data = data.filter((item) => item.id !== id)
    },
};

export const actions = {

    async myBranches({ commit }) {
        await apiClient
            .get(`api/v1/branches/my-branches`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);
    },

    async getBranch({ commit }, data) {
        await apiClient
            .get(`api/v1/branches/show?id=${data.id}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setDetails', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);
    },

    async update({ commit }, data) {
        await apiClient
            .patch(`api/v1/branches/update`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setDetails', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);
    },

    async delete({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .delete(`api/v1/branches/delete?id=${data.id}`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 204) {
                    commit('deleteItem', data.id);
                    commit('app/loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error;
            },);
    },

    async toggle({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .patch(`api/v1/branches/toggle`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateData', response.data.result);
                    commit('app/loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                throw error;
            },);
        commit('app/loadingFinish', null, {root: true});
    },

    async markAsDefault({ commit, dispatch }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .patch('api/v1/branches/mark-as-default', data)
            .then(async response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateData', response.data.result);
                    await dispatch('profile/profile/basic', null, {root: true})
                    await dispatch('myBranches')
                    commit('app/loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                throw error;
            },);
        commit('app/loadingFinish', null, {root: true});
    },

    async create({ commit, dispatch }, data) {
        await apiClient
            .post('api/v1/branches/create', data)
            .then(async response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateData', response.data.result);
                    await dispatch('profile/profile/basic', null, {root: true})
                    await dispatch('myBranches')
                }
            })
            .catch(error => {
                throw error;
            },);
    }
};

export const getters = {
    getData(state) {
        return state.data;
    },
    getDetails(state) {
        return state.details;
    },
    getTotal(state) {
        return state.total;
    },
};
